import React from "react";
import HeroPage from "../../components/HeroPage/HeroPage";



const AllProducts = () => {


  return (
    <>
    {/* <NavBar/> */}
    <div>
      <HeroPage />
    </div>
    {/* <Footer /> */}
    </>
  );
};

export default AllProducts;

